import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'

export type AdditionalCostsValidationResult = {
  additionalCosts?: string[]
}

export type AdditionalCostsProps = {
  label?: string
  showLabelWithTooltip?: boolean
}

const AdditionalCosts: React.FC<FieldProps<AdditionalCostsValidationResult> & AdditionalCostsProps> = ({
  insertionData,
  validationMessages,
  label = 'additionalCosts',
  screenName,
  onChange,
  wrapperClassName = 'grid-item one-whole',
  showLabelWithTooltip = false,
}) => {
  const { t } = useTranslation()

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='additional-costs'
      labelText={t('wizard.screen.costs.additionalCosts')}
      tooltipContent={<PopoverContent translationKey='wizard.screen.costs.additionalCostsHint' />}
      showMandatory={false}
    />
  )

  const labelWithoutTooltip = <span>{t(`wizard.screen.costs.${label}`)}</span>

  return (
    <div className={wrapperClassName}>
      {showLabelWithTooltip && labelWithTooltip}
      <NumberInput
        id='additional-costs'
        propertyName='additionalCosts'
        placeholder=''
        label={showLabelWithTooltip ? '' : labelWithoutTooltip}
        value={insertionData.additionalCosts}
        minPrecision={0}
        maxPrecision={2}
        maxLength={14}
        affixRight='unit'
        unitRight='eur'
        hideMandatorySign={true}
        style={{}}
        errors={validationMessages!.additionalCosts ?? []}
        doOnFieldChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
        }}
      />
    </div>
  )
}
export default AdditionalCosts
